import { selectSearchIsNewSearch } from "../../state/modules/search";

const shouldFetch = ({ state, isNewPage }) =>
  selectSearchIsNewSearch(state) || isNewPage;

export default shouldFetch;
